<template>
  <el-dialog
    ref="dialog"
    class="custom-checkbox-group"
    :title="title"
    :append-to-body="true"
    :visible.sync="visibleDialog"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :before-close="cancelVisiable"
    width="640px"
  >
    <div class="wc-staff-range">
      <div class="left">
        <span v-if="disabledDeptsCom.length" class="title">{{ subTitle }}</span>
        <div class="scroll">
          <CustomTree
            ref="tree"
            v-model="value"
            :data="disabledDeptsCom"
            node-key="id"
            :check-strictly="true"
            :expand-on-click-node="false"
            :props="defaultProps"
            :default-expanded-keys="defaultExpandedKeys"
            :department-list.sync="departmentList"
          />
        </div>
      </div>
      <div class="right">
        <span v-if="disabledDeptsCom.length" class="title">{{ thrTitle }}</span>
        <div class="scroll">
          <div v-for="(item, index) in departmentList" :key="index" class="item item-flex">
            <div>
              <span class="ml-5">{{ item.value }}</span>
            </div>
            <span class="flex-left">
              <i class="el-icon-close" @click="item.del" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" class="line-btn" @click="cancelVisiable">取 消</el-button>
      <el-button size="small" type="primary" @click="setDepartmentCheck">确 定</el-button>
    </span>
  </el-dialog>

</template>

<script>
// eslint-disable-next-line no-unused-vars
const changeDisable = (list = [], disable) => {
  list.forEach(v => {
    if (disable?.includes(v.id)) {
      v.disabled = true
    } else {
      v.disabled = false
    }
    if (v.childList) {
      changeDisable(v.childList, disable)
    }
  })
  return JSON.parse(JSON.stringify(list))
}
export default {
  name: 'DeparTree',
  props: {
    thrTitle: {
      type: String,
      default: '已选范围'
    },
    subTitle: {
      type: String,
      default: '当前可选范围'
    },
    visibleDialog: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: () => '选择部门'
    },
    // 总部门数据
    staffList: {
      type: Array,
      default: () => []
    },
    // 禁用部门
    disabledDepts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      value: {},
      departmentList: [],
      defaultProps: {
        children: 'childList',
        label: 'value',
        disabled: (data) => { return data.type === 1 && !data.visible }
      }
    }
  },
  computed: {
    defaultExpandedKeys() {
      return this.staffList.map(item => item.id)
    },
    // 控制部分部门节点禁用
    disabledDeptsCom() {
      return changeDisable(this.staffList, this.disabledDepts)
    }
  },
  mounted() {
  },
  methods: {
    async init({ departmentList }, refresh) {
      this.$nextTick(async() => {
        this.$refs.tree && this.$refs.tree.init({
          departmentList
        }, () => {
          if (refresh) {
            this.$emit('setDepartment', this.departmentList, this.value)
          }
        })
      })
    },
    // 关闭弹窗
    cancelVisiable() {
      this.clearSearch()
      this.$emit('update:visibleDialog', false)
    },
    // 设置部门
    async setDepartmentCheck() {
      this.clearSearch()
      await this.$nextTick()
      this.$emit('update:visibleDialog', false)
      this.$emit('setDepartment', this.departmentList, this.value)
    },
    clearSearch() {
      this.$refs.tree && this.$refs.tree.clearSearch()
    }
  }
}
</script>

<style scoped lang="scss">
$wit-primary: "#409EFF";
.custom-checkbox-group {
  /deep/ .el-dialog__body {
    border-top: 1px solid #eee;
  }
  .wc-staff-range {
    width: 100%;
    display: flex;
    height: 500px;
    /deep/ .svg-icon {
      &:hover {
        color: $wit-primary !important;
      }
    }
    .left {
      flex: 1;
      padding-top: 16px;
      height: 100%;
      display: flex;
      flex-direction: column;
      /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: $wit-primary;
        border-color: $wit-primary;
      }
      /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        // background-color: #ffff;
        // border-color: #dcdfe6;
      }
    }
    .right {
      flex: 1;
      padding-top: 16px;
      padding-left: 16px;
      height: 100%;
      display: flex;
      flex-direction: column;
      border-left: 1px solid #eee;
      .title{
        margin-bottom: 6px;
      }
      img {
        width: 24px;
        height: 24px;
        margin-right: 5px;
      }
    }
    .title {
      height: 30px;
      line-height: 30px;
      text-align: left;
    }

    .item {
      border-radius: 4px;
      &:hover {
        background: #f5f7fa;
      }
    }

    .item-flex {
      padding: 10px 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        flex: 5;
        display: flex;
        align-items: center;
      }
      .flex-left {
        flex: 1;
        display: flex;
        justify-content: flex-end;
      }
    }
    .scroll {
      flex: 1;
      height: 0;
      overflow-y: auto;
      margin-right: 2px;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
    }
  }
  /deep/ .el-dialog {
    border-radius: 12px;
    margin-top: 10vh !important;
    .el-checkbox,
    .el-checkbox__input {
      display: inline-block;
      position: relative;
      white-space: nowrap;
    }
  }
  /deep/ .el-dialog__title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }
  /deep/ .el-dialog__header {
    padding: 32px 32px 22px 32px;
    .el-dialog__headerbtn{
      top: 32px;
    }
  }
  /deep/ .el-dialog__footer {
    padding: 32px;
  }
  /deep/ .el-dialog__close {
    font-size: 20px;
    color: #000;
    font-weight: 500;
    right: 32px;
  }

  /deep/ .el-dialog__body {
    padding: 0px 32px;
    display: flex;
    .el-tree-node{
      .el-tree-node__content{
        height: 48px;
      }
      .el-tree-node__children{
        .el-tree-node__content{
          height: 40px;
        }
      }
    }
    .el-tree-node__content {
      // padding: 16px 18px;
    }
    &:after {
      visibility: hidden;
      display: block;
      font-size: 0;
      content: " ";
      clear: both;
      height: 0;
    }
  }
}
.el-button {
  padding: 8px 12px;
}
body.sys-deep-style {
  .custom-checkbox-group {
    .wc-staff-range {
      .item:hover {
        background: #343845;
      }
    }
  }
}
</style>
